<template>
  <div :class="$style.loader">
    <div :class="$style.rippleCircle"/>
    <div :class="$style.rippleInnerCircle"/>
  </div>
</template>

<script>
export default {
  name: 'BaseLoader',
};
</script>

<style module lang="scss">
@import '../styles/variables';

.loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rippleCircle,
.rippleInnerCircle {
  position: absolute;
  border: 4px solid $red;
  opacity: 1;
  border-radius: 50%;
}

.rippleCircle {
  animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.rippleInnerCircle {
  animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  animation-delay: -0.5s;
}

@keyframes ripple {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }

  to {
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseLoader.vue